<div *ngIf="section" class="pinned-links">
  <!-- Mobile/Tablet Avatars -->
  <div class="pinned-links__items d-flex d-lg-none flex-nowrap">
    <div
      *ngFor="let link of section.items; trackBy: trackById"
      class="pinned-links__items--link border border-grey-300 bg-white rounded me-35 {{link.style}}">
      <flo-avatar-card
        *ngIf="link.type==='avatar'"
        [image]="link.thumbnailImage.url"
        [href]="link.action.url"
        [primaryLabel]="link.title"
        [secondaryLabel]="link.subtitle"
        [secondaryIcon]="link.secondaryIcon?.style"
        [analyticsProperties]="link.action?.analytics"
        [layout]="link.style"
      ></flo-avatar-card>
      <div
        *ngIf="link.type==='cta-card' && link.action"
        class="w-100 h-100 px-3 py-25 bg-md-grey-300 bg-white border border-grey-300 rounded d-flex align-items-center"
        >
        <ng-container *ngTemplateOutlet="sectionLink; context: { link: link }"></ng-container>
      </div>
    </div>
  </div>
  <!-- Desktop Avatars -->
  <div class="pinned-links__items d-none d-lg-block pb-4">
    <div *ngFor="let link of section.items; let i = index; trackBy: trackById"
         class="pinned-links__items--link no-card primary-color-text-hover"
         [ngClass]="{ 'mt-25': i > 0 }"
    >
      <flo-avatar-card
        *ngIf="link.type==='avatar'"
        [image]="link.thumbnailImage.url"
        [href]="link.action.url"
        [primaryLabel]="link.title"
        [secondaryLabel]="link.subtitle"
        [secondaryIcon]="link.secondaryIcon?.style"
        [analyticsProperties]="link.action?.analytics"
        [layout]="link.style"
      ></flo-avatar-card>
      <div
        *ngIf="link.type==='cta-card' && link.action"
        class="px-3 py-25 bg-grey-300 rounded mt-25"
        >
        <ng-container *ngTemplateOutlet="sectionLink; context: { link: link }"></ng-container>
      </div>
    </div>
    
  </div>
</div>

<ng-template #sectionLink let-link="link">
  <a
    class="view-more-action d-flex align-items-between w-100 svg-vertical-align-middle"
    floAnalytics
    [analyticsProperties]="link.action.analytics"
    [floCustomLink]="link.action.url">
    <span class="flex-grow-1 d-inline-block pe-2">{{link.title}}</span>
    <flo-svg-icon *ngIf="link.action.asset | floIsIcon" [icon]="link.action.asset.style"></flo-svg-icon>
  </a>
</ng-template>
